export default "__VITE_ASSET__BAGNbQjP__"